var o = Object.defineProperty, s = Object.defineProperties;
var m = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var a = (e, n, r) => n in e ? o(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r, t = (e, n) => {
  for (var r in n || (n = {}))
    d.call(n, r) && a(e, r, n[r]);
  if (c)
    for (var r of c(n))
      h.call(n, r) && a(e, r, n[r]);
  return e;
}, i = (e, n) => s(e, m(n));
import { jsx as l } from "react/jsx-runtime";
import { Link as u } from "react-router-dom";
function v(e) {
  const n = e.label || e.children, r = "cursor-pointer text-brand hover:underline active:text-green-900 hover:text-green-900";
  return e.onClick ? /* @__PURE__ */ l("span", i(t({}, e), { className: r, children: n })) : /* @__PURE__ */ l(u, i(t({}, e), { className: r, children: n }));
}
export {
  v as Link
};
